import PropTypes from 'prop-types';

import React from 'react';
import LoadingSkeleton from '../LoadingSkeleton';

const Page = React.lazy(()=>import('../flatpickr/RangePicker'))

export default function LazyRangePicker(props){
    return <React.Suspense fallback={<LoadingSkeleton height={36.5} />}>
        <Page {...props} />
    </React.Suspense>
}



LazyRangePicker.propTypes = {
    onChange: PropTypes.func.isRequired,
    config: PropTypes.any,
    startDate: PropTypes.instanceOf(Date),
    endDate: PropTypes.instanceOf(Date),
};
